const authActions = {
  CANDIDATE_LOGIN:'CANDIDATE_LOGIN',
  RPT_CANDIDATE_LOGIN:"RPT_CANDIDATE_LOGIN"
};

export default authActions;
